import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
import { Response } from "../index.limit";
import { IncomeTax, ReqQueryBillList, ResProfits, ResQueryBillList, Tax, GsLogin, IReqGetIncomeTaxDeclareInfo, IResGetIncomeTaxDeclareInfo, IGetCustomemrTaxDetail, IGetIncomeTaxUserDetail, IGetSocialUserDetail } from "./index.limit";
export * from "./index.limit";
import dayjs from "dayjs";
import { useMainStore } from "@/store";
import { getPeriod } from "@/config";
import { formatThousands } from "@/utils";
import Decimal from "decimal.js";

const { netfile, bs, cwForm, gzb } = baseUrl;
/** 获取个税 */
export const apiQueryBillList = (date: number): Promise<Tax> => {
  const customerInfo = useMainStore().customerInfo.number;
  const params: ReqQueryBillList = {
    declareTime: dayjs(date).format("YYYY-MM"),
    customerInfo,
    pageNo: 1,
    pageSize: 9999,
  };

  return axios
    .get(`${netfile}/api/v1/Decrale/QueryBillList`, {
      isLatest: true,
      params,
    })
    .then((res: ResQueryBillList) => {
      return res.content?.items?.find((n) => n.customerCode == customerInfo) || {};
    });
};
/** 获取个税 - 新 */
export const ApiGetIncomeTaxDeclareInfo = (date: number): Promise<IResGetIncomeTaxDeclareInfo> => {
  const customerId = useMainStore().nowCustomer;
  const data: IReqGetIncomeTaxDeclareInfo = {
    period: Number(dayjs(date).format("YYYYMM")),
    customerId,
  };
  return axios.post(`${bs}/IncomeTax/GetIncomeTaxDeclareInfo`, data, { isLatest: true }).then((res: any) => res.data);
};

/** 获取个税token */
export const apiGsLogin = (data: GsLogin["ReqData"]): Promise<GsLogin["Res"]> => {
  return axios.post(`${netfile}/api/v1/UserInfo/Login`, data, {
    notToken: true,
  });
};

/** 获取工资表 - 个税 */
export const apiWages = (params: { period: string }) => {
  return axios.get(`${gzb}/Wages/Wages`, { isLatest: true, params }).then((res: any) => {
    return res.data[0];
  });
};
/** 获取利润表 - 所得额 */
export const apiProfits = (date: number): Promise<IncomeTax> => {
  const params = {
    ...getPeriod(date),
    template: 1,
    isSetTemplate: false,
    showNullZero: false,
    isShowAllSeason: false,
  };
  return axios
    .get(`${cwForm}/ReportForm/Profits`, {
      isLatest: true,
      params,
    })
    .then((res: Response<ResProfits[]>): IncomeTax => {
      const arr = res.data;
      const obj = {
        currentExpense: new Decimal(0),
      } as IncomeTax;
      // export const ROW_NUM = [[1, "cpdBalanceStr"], 11, 14, 17, 2, 30];
      arr.forEach((n) => {
        switch (n.rowNum) {
          case 1:
            // 营业收入
            obj.currentIncome = formatThousands(n.cpdBalanceStr);
            break;
          case 11:
          case 14:
          case 17:
            obj.currentExpense = obj.currentExpense.add(formatThousands(n.cpdBalanceStr));
            break;
          case 2:
            obj.currentCost = formatThousands(n.cpdBalanceStr);
            break;
          case 30:
            obj.totalProfit = formatThousands(n.cpdBalanceStr);
            break;
          case 31:
            obj.anticipatedIncomeTax = formatThousands(n.cpdBalanceStr);
            break;
        }
      });
      return obj;
    });
};

/**
 * POST
 * /TaxDeclaration/GetCustomemrTaxDetail
 * 微企服获取税务详情
 */
export const ApiGetCustomemrTaxDetail = (params: { customerId: string; period: number }): Promise<IGetCustomemrTaxDetail> => {
  return axios.post(`${bs}/TaxDeclaration/GetCustomemrTaxDetail`, params, { isLatest: true }).then((res: any) => res.data);
};

/**
 * POST
 * /TaxDeclaration/GetIncomeTaxUserDetail
 * 获取工资明细
 */
export const ApiGetIncomeTaxUserDetail = (params: { customerId: string; period: number }): Promise<IGetIncomeTaxUserDetail[]> => {
  return axios.post(`${bs}/TaxDeclaration/GetIncomeTaxUserDetail`, params, { isLatest: true }).then((res: any) => res.data);
};

/**
 * POST
 * /TaxDeclaration/GetSocialUserDetail
 * 社保明细
 */
export const ApiGetSocialUserDetail = (params: { customerId: string; period: number }): Promise<IGetSocialUserDetail[]> => {
  return axios.post(`${bs}/TaxDeclaration/GetSocialUserDetail`, params, { isLatest: true }).then((res: any) => res.data);
};
